<template>
  <div class="venues-block">
    <div class="venues-title fs-xl">体育场馆</div>
    <div class="venues-img">
      <!-- <div class="left-btn"></div>
      <div class="right-btn"></div> -->
      <div class="green-line"></div>
      <div class="images" v-viewer>
        <img
          v-for="(img, index) in images2"
          :key="index"
          :src="img"
          @click="show"
        />
      </div>
      <div></div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer, {
  defaultOptions: {
    button: true,
    navbar: false,
    title: false,
    toolbar: true,
  },
})
export default {
  data() {
    return {
      images2: [
        require('../../../assets/img/image 11.png'),
        require('../../../assets/img/image 14.png'),
        require('../../../assets/img/image 15.png'),
        require('../../../assets/img/imagebg.png'),
      ],
    }
  },
  methods: {
    show() {
      const viewer = this.$el.querySelector('.images').$viewer
      viewer.show()
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../../assets/css/main.scss';
.venues-block {
  width: 1100px;
  z-index: 9;
}
.venues-img {
  width: 100%;
  min-width: 1100px;
  margin-top: 8px;
  //   position: relative;
  img {
    cursor: pointer;
  }
}
.green-line {
  width: 100%;
  min-width: 1100px;
  height: 8px;
  background-color: $lineGreen;
}
.venues-title {
  font-weight: 600;
}
.images ::v-deep .viewer-move {
  margin-top: 25vh !important;
}
</style>
<style lang="scss">
.viewer-move {
  margin-top: 0 !important;
}
.viewer-canvas {
  display: flex;
  align-items: center;
}
</style>
